import React, { useContext } from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';

import { PaymentContext } from 'contexts/paymentContext';
import maskAmount from 'utils/maskAmount';
import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import { CallTo, MailTo } from 'components/common';
import FooterContactUs from './components/footer/FooterContactUs';
import OfferForTheMachineYouAreLookingFor from './components/OfferForTheMachineYouAreLookingFor';

const AmountOfDepositAndBiddingLimit = ({ t }) => {
  const { paymentData } = useContext(PaymentContext);

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('amountOfDepositAndBiddingLimit'),
      url: '/content/amount-of-deposit-and-bidding-limit',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Teminat Bedeli ve Teklif Limiti</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com'da açık artırmalarda teklif vermek isteyen her üye
                  {' '}
                  {maskAmount(paymentData.depositAmount, 'TRY')}
                  'lik teminat bedelini ödemek
                  {' '}
                  <b>zorundadır.</b>
                  {' '}
                  Bu bedel açık artırmanın güvenliğini artırmak, ciddiyetsiz veya art niyetli alıcıların önüne geçmek için tahsil edilmektedir.
                  {' '}
                  <b>Teminat Bedelini istediğiniz zaman geri alabilirsiniz.</b>
                  {' '}
                </p>
                <p>
                  Ödenen
                  {' '}
                  {maskAmount(paymentData.depositAmount, 'TRY')}
                  {' '}
                  karşılığında alıcı toplamda 300.000 Euro'luk bir teklif limiti kazanır.
                  Bu teklif limiti alıcının açık artırmalarda harcayabileceği toplam miktarı temsil eder.
                  Örneğin bir açık artırmada 100.000 Euro'luk bir teklif verdiyseniz, diğer açık artırmalarda toplamda 200.000 Euro tekllif verme hakkınız bulunur.
                  Teminat bedeli arttıkça teklif limitinizi de artırabilirsiniz.
                  Örneğin
                  {' '}
                  {maskAmount(paymentData.depositAmount, 'TRY')}
                  'lik bir teminat bedeli daha yatırırsanız 600.000 Euro'luk bir teklif limitiniz oluşur.
                </p>
                <p>
                  Satıcılar, makinalarını satmak için teminat bedeli ödemek zorunda değillerdir.
                </p>
                <p>
                  Teminat Bedeli ile ilgili sıkıntı yaşıyorsanız veya daha fazla bilgi almak isterseniz bizleri
                  {' '}
                  <CallTo tel="+90 (850) 885 46 25" />
                  {' '}
                  numarasından arayabilir ya da
                  {' '}
                  <MailTo mail="info@iyimakina.com" />
                  {' '}
                  adresine mail atabilirsiniz.
                </p>
              </div>
            </div>
            <OfferForTheMachineYouAreLookingFor />
            <FooterContactUs about="Teminat Bedeli ve Teklif Limiti ile" />
          </div>
        </div>
      </div>
    </main>
  );
};

AmountOfDepositAndBiddingLimit.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Teminat Bedeli ve Teklif Limiti',
    },
  };
};

AmountOfDepositAndBiddingLimit.Layout = Layout;

export default withTranslation('common')(AmountOfDepositAndBiddingLimit);
